import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../Typography';
import Icon from '../Icon';
import './ContextMenu.css';

const ContextMenu = ({ items, ...props }) => {
  if (!items) {
    return null;
  }
  return (
    <div
      data-cy="context-menu"
      className="context-menu-mobile-scroll bg-grey-main relative z-50 block w-[min(calc(100vw-1.5rem),11rem)] overflow-y-auto rounded text-[10px] leading-none shadow-lg scroll-container3 max-h-[calc(1.125rem*4)] sm:w-80 sm:max-h-96 sm:text-sm sm:leading-normal md:w-96"
      onContextMenu={e => e.preventDefault()}
    >
      {items.map((item, index) => (
        <div
          key={index}
          className={`flex h-[1.125rem] min-w-0 cursor-pointer items-center gap-1 px-1 transition duration-300 last:border-b-0 sm:h-auto sm:gap-2 sm:px-2 sm:py-1.5 ${
            item.isActive ? 'bg-primary' : 'hover:bg-primary-dark'
          }`}
          onClick={() => item.action(item, props)}
        >
          <span className="shrink-0 text-[9px] text-common-light sm:text-xs">{index + 1}.</span>
          <div
            className="flex min-w-0 flex-1 items-center justify-between gap-0.5"
            data-cy="context-menu-item"
          >
            <Typography
              variant="caption"
              noWrap
              className="!text-[10px] !leading-tight sm:!text-sm sm:!leading-normal"
            >
              {item.label}
            </Typography>
            {item.iconRight && (
              <Icon
                name={item.iconRight}
                className="inline shrink-0"
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

ContextMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
    })
  ),
};

export default ContextMenu;
